export default __webpack_public_path__ + "static/media/humanity.533be1c6.jpg";